require('./edit-salon.scss')

module.exports = {
  template: require('./edit-salon.pug')()
  controller: require('./edit-salon.ctrl')
  bindings:
    salon: '<'
}
